import React, { createContext, useContext, useEffect } from 'react';
import { useParams } from 'react-router';

import Fallback from '../layout/FallBack';
import { getPlatformConfig, PlatformConfig } from '../layout/platformConfig';
import Authenticated from './Authenticated';
import { useTokenStore } from './TokenStore';

interface AuthContextValue {
  app: string;
  platform: string;
  userType: string;
  platformConfig: PlatformConfig;
}

export interface AuthConfig {
  app: string;
  platform: string;
  userType: string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
export const useAuthContext = () => useContext(AuthContext)!;

const AuthenticationContext = ({ config: { app, platform, userType } }: { config: AuthConfig }) => {
  const { slug } = useParams();
  const platformConfig = getPlatformConfig(platform, slug);
  const tokenStore = useTokenStore();

  useEffect(() => {
    tokenStore.setUserType(userType);
  }, [tokenStore, userType]);

  if (!tokenStore.isReady) return <Fallback />;

  return (
    <AuthContext.Provider value={{ app, platform, userType, platformConfig }}>
      <Authenticated app={app} />
    </AuthContext.Provider>
  );
};

export default AuthenticationContext;
